import { useTranslation } from '@dukanti/shared';
import { RedirectIfAuthed } from '@/components/auth/redirect-if-authed';
import { AuthLayout } from './auth-layout';
import { SignupForm } from './signup-form';

export function SignupRoute() {
  const { t } = useTranslation();
  return (
    <RedirectIfAuthed>
      <AuthLayout
        title={t('admin.authBoundary.missingTitle')}
        subtitle={t('admin.authBoundary.missingBody')}
        testId="signup-route"
      >
        <SignupForm />
      </AuthLayout>
    </RedirectIfAuthed>
  );
}
